import PropTypes from 'prop-types';

import ThumbDownRoundedIcon from '@mui/icons-material/ThumbDownRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import { globalStylesObject } from './materialExports';
import OptionButtonGroup from './OptionButtonGroup';

const centeredButtonBase = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  paddingLeft: 2,
  paddingRight: 2,
};

const centeredLabelBase = {
  marginLeft: 0,
  textAlign: 'center',
};

const YesNoButtonGroup = ({
  selectedValue,
  onYes,
  onNo,
  gap,
  minWidth,
  buttonMinWidth,
}) => {
  const isYesSelected = selectedValue === 'Yes';
  const isNoSelected = selectedValue === 'No';

  const options = [
    {
      key: 'yes',
      label: 'Yes',
      onClick: onYes,
      selected: isYesSelected,
      startIcon: ThumbUpAltRoundedIcon,
      selectedSx: {
        ...globalStylesObject.ButtonSelectedYes,
        ...centeredButtonBase,
      },
      defaultSx: {
        ...globalStylesObject.ButtonEmpty,
        ...centeredButtonBase,
      },
      selectedLabelSx: {
        ...globalStylesObject.TextYes,
        ...centeredLabelBase,
      },
      defaultLabelSx: {
        ...globalStylesObject.Text,
        ...centeredLabelBase,
      },
      buttonProps: { 'aria-pressed': isYesSelected },
    },
    {
      key: 'no',
      label: 'No',
      onClick: onNo,
      selected: isNoSelected,
      startIcon: ThumbDownRoundedIcon,
      selectedSx: {
        ...globalStylesObject.ButtonSelectedNo,
        ...centeredButtonBase,
      },
      defaultSx: {
        ...globalStylesObject.ButtonEmptyNo,
        ...centeredButtonBase,
      },
      selectedLabelSx: {
        ...globalStylesObject.TextNo,
        ...centeredLabelBase,
      },
      defaultLabelSx: {
        ...globalStylesObject.Text,
        ...centeredLabelBase,
      },
      buttonProps: { 'aria-pressed': isNoSelected },
    },
  ];

  return (
    <OptionButtonGroup
      options={options}
      gap={gap}
      minWidth={minWidth}
      buttonMinWidth={buttonMinWidth}
      sx={{
        height: '40px',
      }}
    />
  );
};

YesNoButtonGroup.propTypes = {
  selectedValue: PropTypes.oneOf(['Yes', 'No', null]),
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonMinWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

YesNoButtonGroup.defaultProps = {
  selectedValue: undefined,
  gap: '12px',
  minWidth: '280px',
  buttonMinWidth: '140px',
};

export default YesNoButtonGroup;
